import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 15l4 4m0 -4l-4 4","key":"svg-0"}],["path",{"d":"M7 6v-1h11v1","key":"svg-1"}],["path",{"d":"M7 19l4 0","key":"svg-2"}],["path",{"d":"M13 5l-4 14","key":"svg-3"}]]

const IconClearFormatting = createReactComponent('outline', 'clear-formatting', 'ClearFormatting', __iconNode);

export default IconClearFormatting;